import { render } from "./ApiDocumentationView.vue?vue&type=template&id=10ed7ff1&scoped=true&ts=true"
import script from "./ApiDocumentationView.vue?vue&type=script&lang=ts"
export * from "./ApiDocumentationView.vue?vue&type=script&lang=ts"

import "./ApiDocumentationView.vue?vue&type=style&index=0&id=10ed7ff1&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ed7ff1"]])

export default __exports__